<app-header [showDate]="true" class="timeapp"></app-header>
@let data = data$ | async;
@if (data) {
	<main class="timeapp">
		<div class="page-container">
			<div class="flex-row row-wrapper">
				<div (click)="openAuftragDialog()" [ngClass]="data.auftrag && data.auftrag.objectNumber ? 'selected' : 'not-selected'" class="auftrag flex-row box-shadow">
					<div *ngIf="!data?.auftrag?.objectNumber" class="flex-column">
						<h4>
							{{ "HOME.Auftrag suchen" | translate }} </h4>
						<mat-icon class="timeapp">
							manage_search
						</mat-icon>
					</div>
					
					<div *ngIf="data?.auftrag?.objectNumber" class="flex-col-auftrag">
						<div *ngIf="data.auftrag" class="column">
							<div *ngIf="data.auftrag.objectNumber || data.auftrag.description">
								{{ data!.auftrag.objectNumber }} {{ data!.auftrag.description }}
							</div>
							<div *ngIf="data!.auftrag.note4">
								{{ data!.auftrag.note4 }}
							</div>
							<div *ngIf="data!.auftrag.firstname + data!.auftrag.lastname ">
								{{ data!.auftrag.firstname }} {{ data!.auftrag.lastname }}
							</div>
						</div>
					</div>
				</div>
				<div (click)="openKostenstelleDialog()" [ngClass]="data!.kostenStelle?.costCenterID ? 'selected' : 'not-selected'" class="kostenstelle flex-row box-shadow">
					<div *ngIf="!data!.kostenStelle?.costCenterID">
						<h4>
							{{ "HOME.Kostenstelle" | translate }} </h4>
						<mat-icon class="timeapp">handyman</mat-icon>
					</div>
					<div *ngIf="data!.kostenStelle && data!.kostenStelle.costCenterID">
						<p>
							{{ data!.kostenStelle.costCenterID }}
							{{ data!.kostenStelle.description }} </p>
						<p>
							{{ data!.kostenStelle.arbeitsOrt }} </p>
						<ng-container *ngIf="data!.kostenStelle.description != data!.kostenStelle.text ">
							<p class="text">{{ data!.kostenStelle.text }}</p>
						</ng-container>
					</div>
				</div>
			</div>
			
			<div [ngClass]="checkUserPermission('noDataEditOnHandy') ? 'not-clickable' : ''" class="zeiten flex-row row-wrapper no-flex">
				<div (click)="openStartTimeDialog()" [ngClass]="data!.start ? 'selected' : 'not-selected'" class="startTime flex-row box-shadow">
					<!--<img style="height:8vh" *ngIf="!data.start" src="../../assets/svg_images/Uhr-rot.svg" alt="clock" />-->
					<mat-icon *ngIf="!data!.start" class="timeapp">
						schedule
					</mat-icon>
					<h4 *ngIf="!data!.start">
						{{ "HOME.Startzeit" | translate }} </h4>
					<p *ngIf="data!.start">{{ data!.start | timePipe }}</p>
				</div>
				<div (click)="openEndTimeDialog()" [ngClass]="data!.end ? 'selected' : 'not-selected'" class="endTime flex-row box-shadow">
					<!--<img style="height:8vh" *ngIf="!data.end" src="../../assets/svg_images/Uhr-rot.svg" alt="clock" />-->
					<mat-icon *ngIf="!data!.end" class="timeapp">
						schedule
					</mat-icon>
					<h4 *ngIf="!data!.end">
						{{ "HOME.Endzeit" | translate }} </h4>
					<p *ngIf="data!.end">{{ data!.end | timePipe }}</p>
				</div>
				
				<div (click)="openTimeAmountDialog()" *ngIf="checkUserPermission('allowSaveHoursWithoutTime')" [ngClass]="data!.total ? 'selected' : 'not-selected'"
				     class="startTime flex-row box-shadow">
					<!--<img style="height:8vh" *ngIf="!data.total" src="../../assets/svg_images/Uhr-rot.svg" alt="clock" />-->
					<mat-icon *ngIf="!data!.total" class="timeapp">
						schedule
					</mat-icon>
					<h4 *ngIf="!data!.total">
						{{ "HOME.Zeit" | translate }} </h4>
					<p *ngIf="data!.total" style="text-align: center; word-break: break-all;">{{ data!.total }}</p>
				</div>
			</div>
			<div (click)="openSpesenDialog()" [ngClass]="data && data.spesen && data.spesen.description ? 'selected' : 'not-selected'" class="spesen flex-row box-shadow no-flex">
				<!--<img style="height:8vh" *ngIf="!data.spesen.description" src="../../assets/svg_images/Spesen.svg" alt="spesen" />-->
				<div class="flex-row spesen">
					<mat-icon *ngIf="!data || !data.spesen || !data.spesen.description" class="timeapp">
						payments
					</mat-icon>
					<h4 *ngIf="!data || !data.spesen || !data.spesen.description">
						{{ "HOME.Spesen" | translate }} </h4>
					<p *ngIf="data && data.spesen && data.spesen.description">
						{{ data.spesen.description }} {{ data.spesen.menge }} x
						{{ data.spesen.betrag }} CHF </p>
				</div>
			</div>
			<div (click)="openNotizenDialog()" [ngClass]="data!.notizen ? 'selected' : 'not-selected'" class="notizen flex-row box-shadow">
				<!--<img style="height:8vh" *ngIf="!data.notizen" src="../../assets/svg_images/Notizen.svg" alt="" />-->
				<mat-icon *ngIf="!data!.notizen" class="timeapp">
					description
				</mat-icon>
				<h4 *ngIf="!data!.notizen">
					{{ "HOME.Notizen" | translate }} </h4>
				<p *ngIf="data!.notizen">
					{{ data!.notizen }} </p>
			</div>
			
			<div class="kunde-architect flex-row">
				<div class="kunde box-shadow">
					<h4>
						{{ "HOME.Kunde" | translate }} </h4>
					<div *ngIf="data?.auftrag?.objectNumber">
						<p>{{ data.auftrag.lastname }}</p>
						<p>
							<a class="link" href="http://maps.google.com/?q={{ data.auftrag.city }} {{data.auftrag.zip}} {{ data.auftrag.street1 }}" target="_blank">
								<p>{{ data.auftrag.street1 }}</p>
								<p>{{ data.auftrag.zip }} {{ data.auftrag.city }}</p>
							</a>
						</p>
						<p>
							<a class="link" href="tel:{{ data.auftrag.phone }}">{{ data.auftrag.phone }}</a>
						</p>
						<p>
							<a class="link" href="tel:{{ data.auftrag.phone03 }}">{{ data.auftrag.phone03 }}</a>
						</p>
					</div>
				</div>
				<div class="architect box-shadow">
					<div class="flex-row" style="justify-content: center; column-gap: 0.1em; align-items: center; position: relative;">
						<h4 *ngIf="!toggleBtn">
							{{ "HOME.Lieferadresse:" | translate }} </h4>
						<h4 *ngIf="toggleBtn">
							{{ "HOME.Architekt:" | translate }} </h4>
						<mat-slide-toggle (click)="toggleLieferArchitect()" style="position: absolute; right: 10px;"></mat-slide-toggle>
					</div>
					<div *ngIf="data?.auftrag?.objectNumber && !toggleBtn">
						<p>{{ data.auftrag.liefFirstname }} {{ data.auftrag.liefLastname }}</p>
						<p>
							<a class="link" href="http://maps.google.com/?q={{ data.auftrag.liefCity }} {{data.auftrag.liefZip}} {{ data.auftrag.liefStreet1 }}" target="_blank">
								<p>{{ data.auftrag.liefStreet1 }}</p>
								<p>{{ data.auftrag.liefZip }} {{ data.auftrag.liefCity }}</p>
							</a>
						</p>
						<p>
							<a class="link" href="tel:{{ data.auftrag.liefPhone }}">{{ data.auftrag.liefPhone }}</a>
						</p>
					</div>
					<div *ngIf="data?.auftrag?.objectNumber && toggleBtn">
						<p>{{ data.auftrag.archLastname }}</p>
						<p>
							<a class="link" href="http://maps.google.com/?q={{ data.auftrag.archCity }} {{data.auftrag.archZip}} {{ data.auftrag.archStreet1 }}" target="_blank">
								<p>{{ data.auftrag.archStreet1 }} </p>
								<p>{{ data.auftrag.archZip }} {{ data.auftrag.archCity }}</p>
							</a>
						</p>
						<p>
							<a class="link" href="tel:{{ data.auftrag.archPhone }}">{{ data.auftrag.archPhone }}</a>
						</p>
					</div>
				
				</div>
			</div>
			<div *ngIf="svcVinavonUpdate.updateFound | async" class="vinaupdt flex-row">
				<span>
					<button (click)="svcVinavonUpdate.askUserToDoUpdate()" class="btn-block" color="warn" mat-stroked-button>Update
						vinavon
					</button>
				</span>
			</div>
		</div>
	
	</main>
	<footer class="timeapp">
		<mat-icon (click)="startEndTime()" *ngIf="!data!.end && !startEmptyWorkTime && data!.total === 0" class="icon-footer">
			{{ toggleIcon ? 'pause' : 'schedule' }}
		</mat-icon>
		
		<mat-icon (click)="saveTimeEntry()" *ngIf="data!.end || startEmptyWorkTime || data!.total" class="icon-footer">
			save
		</mat-icon>
		
		<a class="center-img" routerLink="workTimes">
			<mat-icon class="icon-footer">
				calendar_month
			</mat-icon>
		</a>
		
		<ng-container *ngIf="deviceDetection.getDevice().browser.name.includes('Safari')">
			<label class="center-img">
				<mat-icon class="icon-footer" id="files_ios">
					photo_camera
				</mat-icon>
				<input (change)="openCameraSafari($event)" accept="image/*" capture="environment" hidden id="photo_camera_ios" style="visibility: hidden; display: none" type="file"/>
			</label>
		</ng-container>
		<ng-container *ngIf="!deviceDetection.getDevice().browser.name.includes('Safari')">
			<label class="center-img">
				<mat-icon (click)="cameraGuard(camera)" class="icon-footer" id="files">
					photo_camera
				</mat-icon>
			</label>
			<input #camera (change)="openCamera($event)" accept="image/*" capture="environment" hidden id="photo_camera" style="visibility: hidden; display: none" type="file"/>
		</ng-container>
		<ng-container *ngIf="!(hasTimeAppPlusAccess$ | async); else documentsButton">
			<mat-icon (click)="navigateToGallery()" [ngStyle]="{'color': (!data!.auftrag.objectNumber || !data!.auftrag.objectID)? 'lightgrey' : 'white' }" class="icon-footer">
				photo_library
			</mat-icon>
		</ng-container>
		<ng-container *ngIf="hasTimeAppPlusAccess$ | async">
			<mat-icon (click)="navigateToSupplyManagement()" [ngStyle]="{'color': (!data!.auftrag.objectNumber)? 'lightgrey' : 'white' }" class="icon-footer">
				home_improvement_and_tools
			</mat-icon>
		</ng-container>
		<mat-icon (click)="resetDataDialog()" class="icon-footer">
			close
		</mat-icon>
		<mat-icon (click)="dataSync()" [ngStyle]="{'color': !helperService.isWebServiceAvailable()? 'lightgrey' : 'white' }" class="icon-footer">
			sync
		</mat-icon>
	</footer>
	
	<ng-template #documentsButton>
		<mat-icon (click)="navigateToDocuments()" [ngStyle]="{'color': (!data!.auftrag.objectNumber || !data!.auftrag.objectID)? 'lightgrey' : 'white' }" class="icon-footer">
			library_books
		</mat-icon>
	</ng-template>
}